import { Injectable } from '@angular/core';
import { IBullhornCardContext } from '../types/bullhorn-card-context';
import { BullhornEntityType } from '../types/bullhorn/bullhorn-entity-type';

@Injectable({ providedIn: 'root' })
export class BullhornCardContextService {
  getCardContext(params: URLSearchParams): IBullhornCardContext {
    return {
      corporationId: `bullhorn-${Number(params.get('CorporationID')).toString()}`,
      userId: Number(params.get('UserID')),
      cardEntityId: Number(params.get('EntityID')),
      cardEntityType: params.get('EntityType') as BullhornEntityType,
    };
  }
}
